import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import { globalStyles } from './style/gstheme';

const styles = theme => {
  return Object.assign({
    paging: {
      marginTop: 10,
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'center'
    },
    pageButton: {
      minWidth: 40,
      border: 'none',
      marginLeft: 5,
      marginBottom: 4,
      marginRight: 5,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    },
    linkButton: {
      minWidth: 40,
      border: 'none',
      marginLeft: 5,
      marginRight: 5,
      marginBottom: 4,
      padding: 5,
      '&:hover': {
        border: 'none'
      }
    }
  }, globalStyles);
};

class Paging extends Component {

  calcPageRange(current, pageCount, pageItemsRange = 1) {
    let pageRange = [];
    let min = current - pageItemsRange;
    let max = current + pageItemsRange;
    if (min < 1) min = 1;
    if (max > pageCount) max = pageCount;
    for (let i = min; i <= max; i++) { pageRange.push(i); }
    return pageRange;
  }

  handlePageChange(page) {
    this.props.handlePageChange(page);
  }

  render() {

    const { classes, page, pageCount, width, pageItemsRange, showText } = this.props;

    const pageList = this.calcPageRange(page, pageCount, pageItemsRange);

    if (pageCount <= 1) return null;

    return (
      <div id="paging" data-test="paging" className={classes.paging}>
        <span style={{ marginRight: showText ? '10px' : '0px' }}>
          <Button aria-label="Previous page" data-test="page-prev" size="small" onClick={() => this.handlePageChange(page - 1)} disabled={page === 1}>
            <ArrowBack />{showText ? 'Prev' : ''}</Button>
        </span>
        {(width === 'md' || width === 'lg' || width === 'xl') &&
          <div data-test="page-list" style={{ textAlign: 'center', width: pageList.length * 50 + 'px' }}>
            {pageList.map((pageNo, index) =>
              <Button
                aria-label={"Go to page " + pageNo}
                data-test={page === pageNo ? "selected-button" : "unselected-button"}
                key={"button-" + index}
                classes={{
                  containedSizeSmall: classes.pageButton,
                  outlinedSizeSmall: classes.linkButton
                }}
                variant={page === pageNo ? "contained" : "outlined"}
                onClick={() => this.handlePageChange(pageNo)}
                size="small"
                color="primary">
                {pageNo}
              </Button>
            )}
          </div>
        }
        <span style={{ marginLeft: showText ? '10px' : '0px' }}>
          <Button aria-label="Next page" data-test="page-next" size="small" onClick={() => this.handlePageChange(page + 1)} disabled={page === pageCount}>
            {showText ? 'Next' : ''}<ArrowForward />
          </Button>
        </span>
      </div>
    );
  }

}

Paging.defaultProps = {
  pageItemsRange: 1,
  page: 1,
  justify: "space-evenly",
  pageCount: 20,
  showText: true
};

Paging.propTypes = {
  justify: PropTypes.oneOf(["center", "space-evenly"]),
  pageItemsRange: PropTypes.number,
  showText: PropTypes.bool,
  page: PropTypes.number,
  width: PropTypes.string,
  handlePageChange: PropTypes.func.isRequired,
  pageCount: PropTypes.number,
  classes: PropTypes.object
};

export default withWidth()(withStyles(styles)(Paging));